// Administrative pages must fetch the current release instead of an offline shell.
export async function unregister() {
  if (!('serviceWorker' in navigator)) return;
  const scope = new URL(process.env.PUBLIC_URL || '/', window.location.origin).href;
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.filter(registration => {
      const worker = registration.active || registration.waiting || registration.installing;
      return registration.scope === scope && worker && new URL(worker.scriptURL).pathname === '/service-worker.js';
    }).map(registration => registration.unregister()));
    if ('caches' in window) {
      const names = await window.caches.keys();
      await Promise.all(names.filter(name => name.startsWith('workbox-precache-') && name.endsWith(scope)).map(name => window.caches.delete(name)));
    }
  } catch (_) {
    // Cache cleanup must not prevent login or expose browser/auth details.
  }
}
